<template>
  <div></div>
</template>

<script>
import { AiseaApiFactory } from "@/api/aisea/apiFactory";

export default {
  data() {
    return {
      userId: null,
      userName: null,
      active: false
    };
  },
  methods: {
    show(userData) {
      this.userId = userData.id;
      this.userName = userData.name;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `社員削除処理`,
        acceptText: "実行",
        cancelText: "キャンセル",
        text: this.userName + "さんを削除しますか？",
        accept: this.execute
      });
    },
    async execute() {
      try {
        this.$vs.loading();
        await AiseaApiFactory.get("enterpriseUser").delete(this.userId);
        this.$vs.loading.close();
        this.successDelete();
        this.$emit("completeDeleteUser");
      }catch (e) {
        this.$vs.loading.close();
        this.failureDelete(e);
      }

    },
    close() {
      this.active = false;
    },
    cancel() {
      this.active = false;
    },
    successDelete() {
      this.$vs.notify({
        title: this.userName + "さんを削除しました",
        color: "success",
        iconPack: "feather",
        icon: "icon-check",
      });
    },
    failureDelete(e) {
      console.error(e);
      this.$vs.notify({
        title: "削除処理に失敗しました",
        color: "danger",
        iconPack: "feather",
        icon: "icon-x-square",
      });
    }
  }
};
</script>
